<template>
  <ul class="and-condition">
    <template v-for="(id, i) in conditions">
      <or-condition
        :key="id"
        v-model="conditionMap[id].conditions"
        :type="conditionMap[id].type"
        :ref="'orConditions' + id"
        @delete="onDel(id)"
        @change="onChange"
      ></or-condition>
      <li :key="id" v-if="i < conditions.length - 1" class="line">或者</li>
    </template>
    <condition-tag-group
      showPrefix
      prefix="或者"
      v-show="conditions.length < conditionsMax"
      @add="addCondition"
    ></condition-tag-group>
  </ul>
</template>

<script>
import OrCondition from './orCondition'
import ConditionTagGroup from './tagGroup'
import { util } from '../../utils'

export default {
  name: 'andCondition',
  components: {
    ConditionTagGroup,
    OrCondition
  },
  props: {
    value: null,
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['event', 'new', 'active', 'user'].includes(value)
      }
    }
  },
  data() {
    let data = {
      conditionsMax: 3,
      conditions: [],
      conditionMap: {}
    }
    if (this.value && this.value.length) {
      this.value.forEach(condition => {
        let id = util.guid()
        let type = 'user'
        if (condition.eventId >= 0) {
          type = 'event'
        } else {
          switch (condition.eventId) {
            case '-3':
            case -3:
              type = 'new'
              break
            case '-4':
            case -4:
              type = 'active'
              break
          }
        }
        data.conditions.push(id)
        data.conditionMap[id] = {
          type: type,
          conditions: condition
        }
      })
    } else {
      let id = util.guid()
      data.conditions.push(id)
      data.conditionMap[id] = {
        type: this.type,
        conditions: null
      }
    }
    return data
  },
  methods: {
    validate() {
      let result = {
        valid: true,
        errorMsg: ''
      }
      for (let i = 0; i < this.conditions.length; i++) {
        let id = this.conditions[i]
        let orConditions = this.$refs['orConditions' + id]
        for (let j = 0; j < orConditions.length; j++) {
          let condition = orConditions[j]
          let valid = condition.validate()
          if (!valid.valid) {
            result = valid
            return result
          }
        }
      }
      return result
    },
    addCondition(type) {
      let id = util.guid()
      this.conditions.push(id)
      this.conditionMap[id] = {
        type,
        conditions: null
      }
    },
    onChange() {
      let output = []
      this.conditions.map(id => {
        let conditions = this.conditionMap[id].conditions
        if (conditions) output.push(conditions)
      })
      this.$emit('input', output)
      this.$emit('change', output)
    },
    onDel(id) {
      this.conditions.forEach((item, i) => {
        if (id === item) this.conditions.splice(i, 1)
      })
      delete this.conditionMap[id]
      if (!this.conditions.length) this.$emit('delete')
    }
  }
}
</script>

<style lang="sass">
@import "./styles/andCondition"
</style>
